import JasonImage from "../../assets/2025/team/jason.webp";
import YoungkyuImage from "../../assets/2025/team/youngkyu.webp";
import AyumiImage from "../../assets/2025/team/ayumi.webp";
import ManakaImage from "../../assets/2025/team/manaka.webp";
import WeilaiImage from "../../assets/2025/team/weilai.webp";
import ChloeImage from "../../assets/2025/team/chloe.webp";
import SadafImage from "../../assets/2025/team/sadaf.webp";
import DesmondImage from "../../assets/2025/team/desmond.webp";
import HafsahImage from "../../assets/2025/team/hafsah.webp";

const teamMembers = [
  {
    name: "Jason Qiu",
    position: "Chair",
    image: JasonImage,
  },
  {
    name: "Jeong Youngkyu",
    position: "Programmes Head",
    image: YoungkyuImage,
  },
  {
    name: "Ayumi Lim",
    position: "Programmes Head",
    image: AyumiImage,
  },
  {
    name: "Manaka Kuze",
    position: "Logistics Head",
    image: ManakaImage,
  },
  {
    name: "Wei Lai",
    position: "Logistics Head",
    image: WeilaiImage,
  },
  {
    name: "Chloe Sau",
    position: "Publicity Head",
    image: ChloeImage,
  },
  {
    name: "Sadaf Ansari",
    position: "Staff Advisor",
    image: SadafImage,
  },
  {
    name: "Desmond Ng",
    position: "Staff Advisor",
    image: DesmondImage,
  },
  {
    name: "Hafsah Begum",
    position: "Staff Advisor",
    image: HafsahImage,
  },
];

export default teamMembers;
